
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAB7UExURQAAAP////////////////////////////////// //////j4+8zU48XO3+Lm79TZ55KjxIudwKi10Pj5+/Dy99Pa56i20OLn777I3JqpyOns88XN35mp x+nt87bB16GvzJmpyMXO4Nvg68TO39Ta56i1z9Pb5/Hz9wAAAI6voqQAAAAKdFJOUwBAj9/PnyAQ kD+yeUh8AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMBAM5IlSl icsAAADOSURBVCjPhdLbDoMgDAbgisdVcVadTucO7vj+bzgRo7CU7L8ifClNQwGmeMJHK0EYgU6c IBMRzxYgm0Bpgo4IgAid8SB0owCjY5rJ3EQftvO+IKKyMnTDWhmRZPEwGxUsSo3EYq6tYRHLGVse q2NHjWkmYtrnPbKYngb16hnxQtfKxv42dxyVEWUW1to6bXS3MNNzZPhY6k180jLHy7C151hoHAxD WFerfUtZ4ee8fUsAwv3ZIXhunNbTWSr+rSbEbK1e6ilR+FPti526/wJ8WCHXx0yJjgAAACV0RVh0 ZGF0ZTpjcmVhdGUAMjAyMy0xMi0wNFQwMjozMjoxNCswMDowMDWonXgAAAAldEVYdGRhdGU6bW9k aWZ5ADIwMjMtMTItMDRUMDI6MzI6MTQrMDA6MDBE9SXEAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAy MDIzLTEyLTA0VDAzOjU3OjM0KzAwOjAwgs/b5AAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    